import React, { use, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';

import RegistrationForm from './RegistrationForm';
import RegistrationInfo from './RegistrationInfo';

import baseConfig from '../../config/baseConfig.js'
import "./Registration.css"

function Registration() {
  return (
    <Container fluid className="registrationContainer">
      
        <Row>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <RegistrationInfo />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
          {baseConfig.displayRegistrationForm ? (
            <RegistrationForm registrationType="notMember" />
          ) : (
            <Alert variant="info">
              <i className="bi bi-pencil-square"></i> Zapisy na konferencję oraz wydarzenie towarzyszące są zamknięte, do zobaczenia we Wrocławiu!
            </Alert>
          )}
          </Col>
        </Row>
    </Container>
  );
}

export default Registration;
